module.exports = __webpack_public_path__ + "images/24dab6b3b6c5826ca4d56c67a54a06d9.svg";